import { render, staticRenderFns } from "./MultipleResponseItem.vue?vue&type=template&id=05db9e51&scoped=true&"
import script from "./MultipleResponseItem.vue?vue&type=script&lang=js&"
export * from "./MultipleResponseItem.vue?vue&type=script&lang=js&"
import style0 from "./MultipleResponseItem.vue?vue&type=style&index=0&id=05db9e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db9e51",
  null
  
)

export default component.exports